import { vuexBase } from '@/store/compositionV2/base'

const createState = () => ({
  ...vuexBase.createState()
})

const createGetters = () => ({
  ...vuexBase.createGetters()
})

const createMutations = () => ({
  ...vuexBase.createMutations(),

  RESET_STORE: (state) => {
    state.allItemsChecked = false
    state.list = []
    state.currentItem = {}

    state.sort = {}
    state.pagination.perPage = 10
    state.pagination.currentPage = 1
  }
})

const createActions = () => ({
  ...vuexBase.createActions()
})

export const vuexLogistic = {
  createState,
  createGetters,
  createMutations,
  createActions
}
